import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=0b7d5732&scoped=true&lang=pug"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"
import style0 from "./iframe.vue?vue&type=style&index=0&id=0b7d5732&prod&lang=scss"
import style1 from "./iframe.vue?vue&type=style&index=1&id=0b7d5732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d5732",
  null
  
)

export default component.exports